import { NgModule } from '@angular/core';
import { CommonModule, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { NgxPrintModule } from 'ngx-print';
import { StartChangeEmployerComponent } from './start-change-employer/start-change-employer.component';
import { AuthGuard } from '../../shared/security/auth.guard';
import { SelectNewEmployerComponent } from './select-new-employer/select-new-employer.component';
import { ChangeEmployerReviewComponent } from './change-employer-review/change-employer-review.component';
import { ChangeEmployerReceiptComponent } from './change-employer-receipt/change-employer-receipt.component';
import { SeverEmploymentNotificationComponent } from '../sever-employment/sever-employment-notification/sever-employment-notification.component';
import { ChangeEmployerService } from './change-employer.service';
import { PTLSharedModule } from '../../shared/shared.module';
import { ChangeEmployerPayComponent } from './change-employer-pay/change-employer-pay.component';
import { PaymentModule } from '../../shared/payment/payment.module';
import { ChangeEmployerNotificationComponent } from './change-employer-notification/change-employer-notification.component';


const routes: Routes = [
  { path: 'changeEmploying', component: StartChangeEmployerComponent, canActivate: [AuthGuard]},
  { path: 'selectNewEmployer', component: SelectNewEmployerComponent, canActivate: [AuthGuard]}, 
  { path: 'reviewEmployerChange', component: ChangeEmployerReviewComponent, canActivate: [AuthGuard]},
  { path: 'receiptChangeEmployer', component: ChangeEmployerReceiptComponent, canActivate: [AuthGuard]},
  { path: 'changeEmployerNotification', component: ChangeEmployerNotificationComponent, canActivate: [AuthGuard]},
  { path: 'payChangeEmployer', component: ChangeEmployerPayComponent, canActivate: [AuthGuard]},

// severEmploymentNotification
];
@NgModule({
  imports: [
    CommonModule,RouterModule.forChild(routes), FormsModule, PTLSharedModule, NgxPrintModule , PaymentModule
  ],
  
  declarations: [StartChangeEmployerComponent, 
                SelectNewEmployerComponent, ChangeEmployerReviewComponent, ChangeEmployerReceiptComponent, ChangeEmployerPayComponent, ChangeEmployerNotificationComponent],
  providers :[ ChangeEmployerService]
})
export class ChangeEmployerModule { }



// WEBPACK FOOTER //
// ./src/app/broker/change-employer/change-employer.module.ts